var CryptoJS = require("crypto-js");

export const encrypt = (value, secretKey) => {
  if(localStorage.buildVersion && localStorage.buildVersion === "2" && localStorage.versionName === "2.0") {
    return CryptoJS.AES.encrypt(value, secretKey).toString();
  }
  return value;
}

export const decrypt = (value, secretKey) => {
  if(localStorage.buildVersion && localStorage.buildVersion === "2" && localStorage.versionName === "2.0") {
    var decryptedBytes = CryptoJS.AES.decrypt(value.toString(), secretKey);
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
  }
  return value;
}